class LengthImageSelector extends HTMLElement {
  constructor() {
    super();
    this.onLengthChangeBound = this.onLengthChange.bind(this);
    this.onTypeChangeBound = this.onTypeChange.bind(this);
    this.userInteracted = false; // Track if user has clicked
  }

  connectedCallback() {
    this.sectionId = this.getAttribute('data-section-id');
    this.enableGallerySync = this.getAttribute('data-enable-gallery-sync') === 'true';
    this.typeOptionName = this.getAttribute('data-type-option');
    this.lengthItems = this.querySelectorAll('.length-image-selector-item');
    this.setEventListeners();
    this.listenForTypeChanges();
  }

  setEventListeners() {
    this.lengthItems.forEach(item => {
      const input = item.querySelector('input[type="radio"]');
      if (input && !input.disabled) {
        // Only listen for actual user clicks, not programmatic changes
        input.addEventListener('click', this.onLengthChangeBound);
      }
    });
  }

  listenForTypeChanges() {
    // Listen for type option changes from the existing swatch selector
    if (typeof eventBus !== 'undefined') {
      eventBus.on('variant:change', this.onTypeChangeBound);
    }
    
    // Also listen for changes on type option inputs directly
    if (this.typeOptionName) {
      const typeInputs = document.querySelectorAll(`input[name*="${this.typeOptionName}"], select[data-option-name="${this.typeOptionName}"]`);
      typeInputs.forEach(input => {
        input.addEventListener('change', (e) => {
          // Wait a bit for the variant:change event to finish
          setTimeout(() => this.reloadSelector(), 100);
        });
      });
    }
  }

  onTypeChange(eventData) {
    // Don't reload - images should update via Liquid on initial page load
    // This listener is here for future enhancements if needed
  }

  reloadSelector() {
    const currentUrl = window.location.pathname;
    
    let sectionId = this.sectionId;
    console.log('🔵 ORIGINAL section ID:', sectionId);
    
    if (sectionId.includes('template--')) {
      sectionId = sectionId.replace('template--', '');
    }
    
    console.log('🔵 After template-- removal:', sectionId);
    
    const match = sectionId.match(/(\d+__[\w-]+)/);
    if (match) {
      sectionId = match[1];
      console.log('🔵 After regex match:', sectionId);
    }
    
    // Preserve market parameter if present
    const urlParams = new URLSearchParams(window.location.search);
    const marketParam = urlParams.get('market');
    
    let fetchUrl = `${currentUrl}?section_id=${sectionId}`;
    if (marketParam) {
      fetchUrl += `&market=${marketParam}`;
      console.log('🔵 Added market parameter:', marketParam);
    }
    
    // Also check for current variant to maintain context
    const currentVariant = urlParams.get('variant');
    if (currentVariant) {
      fetchUrl += `&variant=${currentVariant}`;
      console.log('🔵 Added variant parameter:', currentVariant);
    }
    
    console.log('🔵 Final fetch URL:', fetchUrl);
    
    fetch(fetchUrl)
      .then(response => {
        console.log('🔵 Fetch response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        console.log('✅ Received HTML, parsing...');
        console.log('🔵 HTML length:', html.length);
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSelector = doc.querySelector('length-image-selector');
        
        if (newSelector) {
          console.log('✅ Found new selector in HTML');
          const newItems = newSelector.querySelector('.length-image-selector-items');
          const currentItems = this.querySelector('.length-image-selector-items');
          
          if (newItems && currentItems) {
            console.log('✅ Updating items, new HTML length:', newItems.innerHTML.length);
            currentItems.innerHTML = newItems.innerHTML;
            
            this.lengthItems = this.querySelectorAll('.length-image-selector-item');
            this.setEventListeners();
            
            const wasInteracted = this.userInteracted;
            this.userInteracted = false;
            
            const firstAvailable = this.querySelector('.length-image-selector-item.available input');
            if (firstAvailable) {
              firstAvailable.checked = true;
              firstAvailable.closest('.length-image-selector-item').classList.add('active');
              
              const variantId = firstAvailable.closest('.length-image-selector-item').getAttribute('data-variant-id');
              const fullImageUrl = firstAvailable.closest('.length-image-selector-item').getAttribute('data-full-image');
              
              console.log('✅ Auto-selected first variant:', variantId);
              console.log('✅ Full image URL:', fullImageUrl);
              
              if (fullImageUrl) {
                this.updateMainGalleryImage(fullImageUrl);
              }
              
              this.userInteracted = wasInteracted;
              this.updateVariant(variantId, fullImageUrl);
            }
          } else {
            console.log('❌ Could not find items containers');
          }
        } else {
          console.log('❌ Could not find length-image-selector in fetched HTML');
          console.log('🔍 HTML preview:', html.substring(0, 500));
        }
      })
      .catch(error => {
        console.error('❌ Failed to reload length selector:', error);
      });
  }

  onLengthChange(event) {
    // Mark that user has interacted
    this.userInteracted = true;
    
    const input = event.target;
    const item = input.closest('.length-image-selector-item');
    const variantId = item.getAttribute('data-variant-id');
    
    // Get the FULL image URL from data attribute (from type product)
    let fullImageUrl = item.getAttribute('data-full-image');
    
    if (fullImageUrl) {
      // Ensure it has protocol
      if (fullImageUrl.startsWith('//')) {
        fullImageUrl = 'https:' + fullImageUrl;
      }
      
      // Only update gallery if user actually clicked (not on page load)
      this.updateMainGalleryImage(fullImageUrl);
    }

    this.updateActiveState(item);
    this.updateVariant(variantId, fullImageUrl);
  }

  updateActiveState(selectedItem) {
    this.lengthItems.forEach(item => {
      item.classList.remove('active');
    });
    selectedItem.classList.add('active');
  }

  updateVariant(variantId, fullSizeImageSrc) {
    const productForm = document.querySelector(`#product-form-${this.sectionId}`);
    
    if (productForm) {
      const variantInput = productForm.querySelector('select[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
        // Don't trigger change event on initial load - only when user interacts
        if (this.userInteracted) {
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // Only emit variant:change event if user has interacted
    if (this.userInteracted) {
      const variantData = this.getVariantById(variantId);
      
      if (variantData && typeof eventBus !== 'undefined') {
        eventBus.emit('variant:change', {
          sectionId: this.sectionId,
          variant: variantData,
          fetchURL: `${window.location.pathname}?variant=${variantId}`,
          productURL: window.location.pathname,
          isCombinedListing: false
        });
      }
    }
  }
  
  updateMainGalleryImage(imageSrc) {
    const mainImageSelectors = [
      '.swiper-slide-active img',
      '.product-single__photo img',
      '.product__main-photos img:first-of-type',
      '[data-product-featured-media] img',
      '.product-featured-media img',
      'img[data-image-id]'
    ];
    
    let mainImage = null;
    for (const selector of mainImageSelectors) {
      mainImage = document.querySelector(selector);
      if (mainImage && !mainImage.classList.contains('product-medias__thumbnail__image')) {
        break;
      }
    }
    
    if (mainImage) {
      let imageUrl = imageSrc;
      
      if (imageUrl.startsWith('//')) {
        imageUrl = 'https:' + imageUrl;
      }
      
      mainImage.src = imageUrl;
      mainImage.srcset = imageUrl;
    }
  }

  getVariantById(variantId) {
    const inputId = this.querySelector(`input[value="${variantId}"]`)?.id;
    
    if (inputId) {
      const variantScript = document.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
      if (variantScript) {
        return JSON.parse(variantScript.textContent);
      }
    }

    const allScripts = this.querySelectorAll('script[type="application/json"]');
    for (let script of allScripts) {
      const data = JSON.parse(script.textContent);
      if (data && data.id == variantId) {
        return data;
      }
    }

    return null;
  }

  disconnectedCallback() {
    this.lengthItems.forEach(item => {
      const input = item.querySelector('input[type="radio"]');
      if (input) {
        input.removeEventListener('click', this.onLengthChangeBound);
      }
    });
    
    if (typeof eventBus !== 'undefined') {
      eventBus.off('variant:change', this.onTypeChangeBound);
    }
  }
}

if (!window.customElements.get('length-image-selector')) {
  window.customElements.define('length-image-selector', LengthImageSelector);
}

